import { updateAuthHeader } from '@services/axios';
import { checkIfJWTIsValid } from '@store/userStore/userStore.functions';
import useUserPersonalData from 'src/apis/queries/useUserPersonalData';
import { IIsLoggedIn } from './useIsLoggedIn.type';

const useIsLoggedIn = () =>
	useUserPersonalData<IIsLoggedIn>(({ jwt }) => {
		updateAuthHeader(jwt);

		if (!jwt || !checkIfJWTIsValid(jwt)) {
			return { isLoggedIn: false };
		}

		return { isLoggedIn: true };
	});

export { useIsLoggedIn };
